import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useTheme } from '../contexts/ThemeContext';

// Use empty string if REACT_APP_BACKEND_URL is undefined or empty
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const WHITE_LOGO = "/images/logos/logo-white.png";
const BLACK_LOGO = "/images/logos/logo-black.png";

// ---- FLAT VECTOR PEOPLE SCENES ----

const TravelScene = ({ isDark }) => (
  <g>
    <rect x="2" y="52" width="18" height="24" rx="3" fill="#00D4AA" />
    <rect x="8" y="48" width="6" height="5" rx="2" fill="#00D4AA" stroke={isDark ? '#0a0a0a' : '#fff'} strokeWidth="1" />
    <line x1="2" y1="60" x2="20" y2="60" stroke={isDark ? '#0a0a0a' : '#fff'} strokeWidth="0.8" opacity="0.5" />
    <circle cx="6" cy="78" r="2" fill={isDark ? '#333' : '#1a1a1a'} />
    <circle cx="16" cy="78" r="2" fill={isDark ? '#333' : '#1a1a1a'} />
    <circle cx="38" cy="14" r="10" fill="#d4a574" />
    <path d="M32,10 Q32,4 38,4 Q44,4 44,10" fill="#2a1a0a" />
    <rect x="28" y="24" width="20" height="28" rx="4" fill={isDark ? '#1e1e1e' : '#111'} />
    <rect x="30" y="26" width="16" height="14" rx="2" fill="#00D4AA" opacity="0.7" />
    <rect x="28" y="52" width="8" height="24" rx="3" fill={isDark ? '#2a2a2a' : '#1a1a1a'} />
    <rect x="40" y="52" width="8" height="24" rx="3" fill={isDark ? '#333' : '#222'} />
    <rect x="44" y="22" width="12" height="22" rx="3" fill="#0098d4" opacity="0.8" />
    <rect x="46" y="26" width="8" height="4" rx="1" fill={isDark ? '#0a0a0a' : '#fff'} opacity="0.3" />
  </g>
);

const MovingScene = ({ isDark }) => (
  <g>
    <rect x="0" y="52" width="30" height="16" rx="4" fill="#0098d4" />
    <rect x="0" y="50" width="6" height="4" rx="2" fill="#0098d4" />
    <rect x="24" y="50" width="6" height="4" rx="2" fill="#0098d4" />
    <rect x="0" y="68" width="4" height="6" rx="1" fill={isDark ? '#333' : '#222'} />
    <rect x="26" y="68" width="4" height="6" rx="1" fill={isDark ? '#333' : '#222'} />
    <rect x="34" y="30" width="18" height="16" rx="1" fill={isDark ? '#2a2a2a' : '#1a1a1a'} />
    <line x1="43" y1="30" x2="43" y2="46" stroke="#00D4AA" strokeWidth="1" opacity="0.5" />
    <line x1="34" y1="38" x2="52" y2="38" stroke="#00D4AA" strokeWidth="1" opacity="0.5" />
    <circle cx="43" cy="16" r="10" fill="#c9a882" />
    <path d="M37,12 Q37,5 43,5 Q49,5 49,12" fill={isDark ? '#1a1a1a' : '#111'} />
    <rect x="35" y="26" width="16" height="6" rx="2" fill="#00D4AA" />
    <rect x="30" y="30" width="5" height="14" rx="2" fill="#c9a882" />
    <rect x="51" y="30" width="5" height="14" rx="2" fill="#c9a882" />
    <rect x="35" y="46" width="8" height="26" rx="3" fill={isDark ? '#2a2a2a' : '#1a1a1a'} />
    <rect x="45" y="46" width="8" height="26" rx="3" fill={isDark ? '#333' : '#222'} />
  </g>
);

const WeddingScene = ({ isDark }) => (
  <g>
    <circle cx="18" cy="14" r="9" fill="#b58960" />
    <path d="M12,10 Q12,4 18,4 Q24,4 24,10" fill={isDark ? '#1a1a1a' : '#111'} />
    <rect x="10" y="23" width="16" height="30" rx="3" fill={isDark ? '#1e1e1e' : '#111'} />
    <polygon points="18,23 14,32 22,32" fill="white" opacity="0.6" />
    <circle cx="18" cy="28" r="1.5" fill="#00D4AA" />
    <rect x="10" y="53" width="7" height="22" rx="3" fill={isDark ? '#2a2a2a' : '#1a1a1a'} />
    <rect x="19" y="53" width="7" height="22" rx="3" fill={isDark ? '#333' : '#222'} />
    <circle cx="42" cy="12" r="9" fill="#e0c9a8" />
    <path d="M35,9 Q34,2 42,2 Q50,2 49,9 L49,14 Q49,18 46,18 L38,18 Q35,18 35,14 Z" fill="#3a2a1a" />
    <path d="M42,2 Q55,-2 56,15 Q56,25 50,30" stroke="white" strokeWidth="0.8" fill="white" fillOpacity="0.15" />
    <path d="M33,22 L33,72 Q37,78 42,78 Q47,78 51,72 L51,22 Z" fill="#00D4AA" />
    <path d="M33,72 Q30,78 28,78 L56,78 Q54,78 51,72 Z" fill="#00BF9A" />
    <circle cx="30" cy="42" r="5" fill="#00D4AA" opacity="0.6" />
    <circle cx="28" cy="40" r="3" fill="white" opacity="0.4" />
    <circle cx="32" cy="39" r="3" fill="#00D4AA" opacity="0.4" />
  </g>
);

const CarScene = ({ isDark }) => (
  <g>
    <path d="M5,50 L5,62 Q5,66 9,66 L51,66 Q55,66 55,62 L55,50 Q55,46 51,46 L9,46 Q5,46 5,50Z" fill="#0098d4" />
    <path d="M14,46 L18,34 L42,34 L46,46 Z" fill="#0098d4" />
    <path d="M16,45 L19,36 L41,36 L44,45 Z" fill={isDark ? '#1a1a1a' : '#cceeff'} opacity={isDark ? '0.5' : '0.7'} />
    <circle cx="16" cy="66" r="6" fill={isDark ? '#333' : '#222'} />
    <circle cx="16" cy="66" r="3" fill={isDark ? '#555' : '#444'} />
    <circle cx="44" cy="66" r="6" fill={isDark ? '#333' : '#222'} />
    <circle cx="44" cy="66" r="3" fill={isDark ? '#555' : '#444'} />
    <rect x="51" y="52" width="4" height="4" rx="1" fill="#00D4AA" opacity="0.8" />
    <circle cx="38" cy="14" r="8" fill="#d4a574" />
    <path d="M33,10 Q33,5 38,5 Q43,5 43,10" fill={isDark ? '#1a1a1a' : '#111'} />
    <rect x="31" y="22" width="14" height="14" rx="3" fill="#00D4AA" />
    <rect x="31" y="36" width="6" height="18" rx="3" fill={isDark ? '#2a2a2a' : '#1a1a1a'} />
    <rect x="39" y="36" width="6" height="18" rx="3" fill={isDark ? '#333' : '#222'} />
  </g>
);

// Hexagonal badge - CROPPED tighter around text
const HexBadge = ({ x, y, text, scale = 1 }) => {
  const w = 68 * scale; // Wider for bigger text
  const h = 26 * scale; // Much shorter height for tight crop
  const hw = w / 2;
  const hh = h / 2;
  const indent = 9 * scale;
  return (
    <g transform={`translate(${x}, ${y})`}>
      <polygon
        points={`${indent},0 ${w - indent},0 ${w},${hh} ${w - indent},${h} ${indent},${h} 0,${hh}`}
        fill="#00D4AA"
      />
      <text x={hw} y={hh + 4.5 * scale} textAnchor="middle" fill="white" fontSize={10 * scale} fontFamily="Inter, sans-serif" fontWeight="700">{text}</text>
    </g>
  );
};

// Charity logo without container - clean and simple, BIGGER
const CharityLogo = ({ x, y, url, alt, scale = 1 }) => {
  const size = 90 * scale; // Increased from 70 to 90
  
  return (
    <g transform={`translate(${x}, ${y})`}>
      <image 
        href={url} 
        x={0} 
        y={0} 
        width={size} 
        height={size}
        preserveAspectRatio="xMidYMid meet"
        opacity="0.95"
      />
    </g>
  );
};

// Full scattered hero illustration
const HeroIllustration = ({ isDark }) => (
  <div className="relative w-full max-w-xl mx-auto">
    <svg viewBox="0 0 480 480" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
      <defs>
        <linearGradient id="hexGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00D4AA" />
          <stop offset="100%" stopColor="#00BF9A" />
        </linearGradient>
      </defs>

      {/* Soft background */}
      <ellipse cx="240" cy="240" rx="230" ry="220" fill={isDark ? 'rgba(0,212,170,0.03)' : 'rgba(0,212,170,0.05)'} />

      {/* --- FLOATING HEXAGONS - MANY MORE HEXAGONS, WITHIN BOUNDS --- */}
      <g opacity="0.55">
        <polygon points="430,25 458,40 458,70 430,85 402,70 402,40" fill="url(#hexGrad)" fillOpacity="0.2" stroke="#00D4AA" strokeWidth="1.2" strokeOpacity="0.5" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-10;0,0" dur="5s" repeatCount="indefinite" />
      </g>
      <g opacity="0.45">
        <polygon points="25,60 47,72 47,96 25,108 3,96 3,72" fill="url(#hexGrad)" fillOpacity="0.15" stroke="#00D4AA" strokeWidth="1" strokeOpacity="0.35" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-8;0,0" dur="6s" repeatCount="indefinite" />
      </g>
      <g opacity="0.4">
        <polygon points="455,280 471,289 471,307 455,316 439,307 439,289" fill="#00D4AA" fillOpacity="0.2" stroke="#00D4AA" strokeWidth="0.6" strokeOpacity="0.25" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-6;0,0" dur="4.5s" repeatCount="indefinite" />
      </g>
      <g opacity="0.35">
        <polygon points="18,355 32,362 32,376 18,383 4,376 4,362" fill="#00D4AA" fillOpacity="0.18" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-5;0,0" dur="5.5s" repeatCount="indefinite" />
      </g>
      <g opacity="0.3">
        <polygon points="375,420 387,427 387,439 375,446 363,439 363,427" fill="#00D4AA" fillOpacity="0.15" stroke="#00D4AA" strokeWidth="0.5" strokeOpacity="0.2" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-4;0,0" dur="7s" repeatCount="indefinite" />
      </g>
      <g opacity="0.25">
        <polygon points="230,8 242,15 242,27 230,34 218,27 218,15" fill="#00D4AA" fillOpacity="0.2" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-6;0,0" dur="4s" repeatCount="indefinite" />
      </g>
      {/* ADDITIONAL HEXAGONS - within bounds */}
      <g opacity="0.38">
        <polygon points="115,25 133,35 133,55 115,65 97,55 97,35" fill="url(#hexGrad)" fillOpacity="0.18" stroke="#00D4AA" strokeWidth="0.8" strokeOpacity="0.3" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-7;0,0" dur="5.5s" repeatCount="indefinite" begin="1s" />
      </g>
      <g opacity="0.32">
        <polygon points="320,460 334,467 334,481 320,488 306,481 306,467" fill="#00D4AA" fillOpacity="0.16" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-5;0,0" dur="6.5s" repeatCount="indefinite" begin="0.5s" />
      </g>
      <g opacity="0.42">
        <polygon points="65,200 79,207 79,221 65,228 51,221 51,207" fill="url(#hexGrad)" fillOpacity="0.2" stroke="#00D4AA" strokeWidth="0.7" strokeOpacity="0.28" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-6;0,0" dur="7s" repeatCount="indefinite" begin="2s" />
      </g>
      <g opacity="0.36">
        <polygon points="410,180 424,187 424,201 410,208 396,201 396,187" fill="#00D4AA" fillOpacity="0.17" stroke="#00D4AA" strokeWidth="0.6" strokeOpacity="0.25" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-5;0,0" dur="5s" repeatCount="indefinite" begin="1.5s" />
      </g>
      <g opacity="0.28">
        <polygon points="155,450 167,457 167,469 155,476 143,469 143,457" fill="#00D4AA" fillOpacity="0.15" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-4;0,0" dur="6s" repeatCount="indefinite" begin="3s" />
      </g>
      {/* MORE NEW HEXAGONS */}
      <g opacity="0.33">
        <polygon points="180,30 194,37 194,51 180,58 166,51 166,37" fill="url(#hexGrad)" fillOpacity="0.19" stroke="#00D4AA" strokeWidth="0.7" strokeOpacity="0.28" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-6;0,0" dur="5.8s" repeatCount="indefinite" begin="0.8s" />
      </g>
      <g opacity="0.39">
        <polygon points="295,120 307,127 307,139 295,146 283,139 283,127" fill="#00D4AA" fillOpacity="0.18" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-5;0,0" dur="6.2s" repeatCount="indefinite" begin="1.2s" />
      </g>
      <g opacity="0.31">
        <polygon points="35,280 49,287 49,301 35,308 21,301 21,287" fill="url(#hexGrad)" fillOpacity="0.16" stroke="#00D4AA" strokeWidth="0.6" strokeOpacity="0.24" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-7;0,0" dur="7.2s" repeatCount="indefinite" begin="2.5s" />
      </g>
      <g opacity="0.27">
        <polygon points="445,350 457,357 457,369 445,376 433,369 433,357" fill="#00D4AA" fillOpacity="0.14" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-4;0,0" dur="5.4s" repeatCount="indefinite" begin="1.8s" />
      </g>
      <g opacity="0.35">
        <polygon points="200,380 212,387 212,399 200,406 188,399 188,387" fill="url(#hexGrad)" fillOpacity="0.17" stroke="#00D4AA" strokeWidth="0.5" strokeOpacity="0.22" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-5;0,0" dur="6.8s" repeatCount="indefinite" begin="3.2s" />
      </g>
      <g opacity="0.29">
        <polygon points="340,25 352,32 352,44 340,51 328,44 328,32" fill="#00D4AA" fillOpacity="0.15" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-6;0,0" dur="5.2s" repeatCount="indefinite" begin="2.1s" />
      </g>
      <g opacity="0.37">
        <polygon points="125,150 137,157 137,169 125,176 113,169 113,157" fill="url(#hexGrad)" fillOpacity="0.18" stroke="#00D4AA" strokeWidth="0.6" strokeOpacity="0.26" />
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-5;0,0" dur="6.6s" repeatCount="indefinite" begin="0.4s" />
      </g>

      {/* Sparkle dots */}
      <circle cx="95" cy="140" r="2.5" fill="#00D4AA" opacity="0.3"><animate attributeName="opacity" values="0.3;0.7;0.3" dur="3s" repeatCount="indefinite" /></circle>
      <circle cx="400" cy="175" r="2" fill="#00D4AA" opacity="0.25"><animate attributeName="opacity" values="0.25;0.6;0.25" dur="4s" repeatCount="indefinite" begin="1s" /></circle>
      <circle cx="280" cy="450" r="2" fill="#00D4AA" opacity="0.2"><animate attributeName="opacity" values="0.2;0.5;0.2" dur="3.5s" repeatCount="indefinite" begin="0.5s" /></circle>
      <circle cx="55" cy="430" r="1.5" fill="#00D4AA" opacity="0.25"><animate attributeName="opacity" values="0.25;0.55;0.25" dur="5s" repeatCount="indefinite" begin="2s" /></circle>

      {/* Rotating stars */}
      <g transform="translate(370,55)">
        <polygon points="6,0 7.5,4.5 12,5.5 8.5,8.5 9.5,13 6,10.5 2.5,13 3.5,8.5 0,5.5 4.5,4.5" fill="#00D4AA" opacity="0.4">
          <animateTransform attributeName="transform" type="rotate" values="0 6 6.5;360 6 6.5" dur="10s" repeatCount="indefinite" />
        </polygon>
      </g>
      <g transform="translate(50,290)">
        <polygon points="5,0 6.2,3.5 10,4.2 7.2,6.8 7.8,10.5 5,8.5 2.2,10.5 2.8,6.8 0,4.2 3.8,3.5" fill="#00D4AA" opacity="0.3">
          <animateTransform attributeName="transform" type="rotate" values="0 5 5.2;-360 5 5.2" dur="12s" repeatCount="indefinite" />
        </polygon>
      </g>

      {/* Floating hearts */}
      <path d="M175,38 C175,35 177.5,33.5 179,35.5 C180.5,33.5 183,35 183,38 C183,41.5 179,44 179,44 C179,44 175,41.5 175,38Z" fill="#00D4AA" opacity="0.5">
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-4;0,0" dur="3.5s" repeatCount="indefinite" />
      </path>
      <path d="M355,340 C355,337 357.5,335.5 359,337.5 C360.5,335.5 363,337 363,340 C363,343.5 359,346 359,346 C359,346 355,343.5 355,340Z" fill="#00D4AA" opacity="0.4">
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-3;0,0" dur="4s" repeatCount="indefinite" begin="1s" />
      </path>

      {/* ---- SCATTERED SCENES + LABELS + CHARITY LOGOS - NO OVERLAPS ---- */}

      {/* Scene 1: Travelling — top-left area, slight rotate - MASSIVE */}
      <g transform="translate(5, 60) rotate(-3, 55, 50) scale(1.9)">
        <TravelScene isDark={isDark} />
      </g>
      <HexBadge x={0} y={215} text="Travelling?" scale={1.5} />

      {/* Scene 2: Moving — upper-right, rotated - MASSIVE */}
      <g transform="translate(255, 15) rotate(4, 30, 45) scale(1.8)">
        <MovingScene isDark={isDark} />
      </g>
      <HexBadge x={260} y={160} text="Moving?" scale={1.45} />

      {/* Scene 3: Wedding — mid-left, slight tilt - MASSIVE */}
      <g transform="translate(115, 180) rotate(2, 30, 40) scale(1.85)">
        <WeddingScene isDark={isDark} />
      </g>
      <HexBadge x={125} y={335} text="Married?" scale={1.45} />

      {/* Scene 4: Car — bottom-right - MASSIVE */}
      <g transform="translate(270, 250) rotate(-2, 30, 35) scale(1.85)">
        <CarScene isDark={isDark} />
      </g>
      <HexBadge x={285} y={405} text="New car?" scale={1.45} />

      {/* CHARITY LOGOS - REPOSITIONED TO AVOID OVERLAPS, ALL WITHIN BOUNDS */}
      
      {/* Charity: RSPCA — top right edge, clear of moving scene */}
      <CharityLogo x={390} y={5} url="/images/charities/rspca.svg" alt="RSPCA" scale={1.0} />

      {/* Charity: Oxfam — right edge, between moving and car */}
      <CharityLogo x={390} y={175} url="/images/charities/oxfam.png" alt="Oxfam" scale={0.95} />

      {/* Charity: BHF — top center, above wedding scene */}
      <CharityLogo x={175} y={5} url="/images/charities/bhf.png" alt="British Heart Foundation" scale={0.95} />

      {/* Charity: Mind — left edge, between travel and wedding */}
      <CharityLogo x={5} y={265} url="/images/charities/mind.png" alt="Mind" scale={0.95} />

      {/* Charity: RNLI — right edge below oxfam, above new car label */}
      <CharityLogo x={390} y={315} url="/images/charities/rnli.png" alt="RNLI" scale={0.9} />

      {/* Charity: Macmillan — bottom left corner, clear of all scenes */}
      <CharityLogo x={5} y={385} url="/images/charities/macmillan.png" alt="Macmillan" scale={1.0} />

      {/* Charity: Dogs Trust — bottom center-left, within bounds */}
      <CharityLogo x={135} y={375} url="/images/charities/dogs-trust.png" alt="Dogs Trust" scale={0.9} />

      {/* Platform shadow */}
      <ellipse cx="240" cy="465" rx="190" ry="10" fill={isDark ? 'rgba(0,212,170,0.025)' : 'rgba(0,212,170,0.04)'} />
    </svg>
  </div>
);

// Background orbs
const BackgroundOrbs = ({ isDark }) => (
  <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
    <div className="absolute w-[600px] h-[600px] rounded-full animate-pulse-glow"
      style={{ background: `radial-gradient(circle, rgba(0,212,170,${isDark ? '0.15' : '0.08'}) 0%, transparent 70%)`, top: '-10%', right: '-5%' }} />
    <div className="absolute w-[500px] h-[500px] rounded-full animate-pulse-glow"
      style={{ background: `radial-gradient(circle, rgba(0,191,154,${isDark ? '0.1' : '0.06'}) 0%, transparent 70%)`, bottom: '-5%', left: '-10%', animationDelay: '2s' }} />
    <div className="absolute w-[300px] h-[300px] rounded-full animate-float"
      style={{ background: `radial-gradient(circle, rgba(0,212,170,${isDark ? '0.08' : '0.05'}) 0%, transparent 70%)`, top: '40%', left: '30%' }} />
    {isDark && (
      <div className="absolute inset-0 opacity-[0.03]"
        style={{ backgroundImage: 'linear-gradient(rgba(0,212,170,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(0,212,170,0.3) 1px, transparent 1px)', backgroundSize: '60px 60px' }} />
    )}
  </div>
);

const ThemeToggle = ({ isDark, toggleTheme }) => (
  <button onClick={toggleTheme} aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    className={`relative w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 ${isDark ? 'bg-white/10 hover:bg-white/20 text-yellow-300' : 'bg-gray-100 hover:bg-gray-200 text-gray-600'}`}>
    {isDark ? (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
    ) : (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" /></svg>
    )}
  </button>
);

const StatusBadge = () => (
  <div className="inline-flex items-center space-x-2 bg-[#00D4AA]/10 border border-[#00D4AA]/30 rounded-full px-4 py-1.5 sm:px-5 sm:py-2">
    <div className="w-2 h-2 bg-[#00D4AA] rounded-full animate-pulse" />
    <span className="text-[#00D4AA] text-xs sm:text-sm font-semibold tracking-wide uppercase">Coming Soon</span>
  </div>
);

const FeaturePill = ({ icon, text, delay, isDark }) => (
  <div className={`animate-fade-in-up opacity-0 delay-${delay} inline-flex items-center space-x-2 backdrop-blur-sm border rounded-full px-4 py-2 text-sm ${isDark ? 'bg-white/5 border-white/10 text-gray-300' : 'bg-gray-50 border-gray-200 text-gray-600'}`}>
    <span className="text-[#00D4AA]">{icon}</span>
    <span>{text}</span>
  </div>
);

const EmailSignup = ({ compact = false, isDark }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    setMessage('');
    try {
      const response = await axios.post(`${BACKEND_URL}/api/subscribe`, { email_address: email });
      if (response.data.success) {
        setStatus('success'); setMessage(response.data.message); setEmail('');
        if (window.gtag) window.gtag('event', 'sign_up', { method: 'email_waitlist' });
      } else { setStatus('error'); setMessage(response.data.message || 'Something went wrong.'); }
    } catch (err) { setStatus('error'); setMessage(err.response?.data?.detail || 'Unable to subscribe. Please try again later.'); }
  };

  return (
    <div className={`w-full ${compact ? 'max-w-xl mx-auto' : 'max-w-lg'}`}>
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col sm:flex-row gap-3">
          <input type="email" value={email}
            onChange={(e) => { setEmail(e.target.value); if (status !== 'idle') setStatus('idle'); }}
            placeholder="Enter your email address" required disabled={status === 'loading'}
            className={`flex-1 px-5 py-4 backdrop-blur-sm border rounded-xl focus:outline-none focus:border-[#00D4AA]/50 focus:ring-2 focus:ring-[#00D4AA]/20 transition-all duration-300 disabled:opacity-50 ${isDark ? 'bg-white/5 border-white/10 text-white placeholder-gray-500' : 'bg-gray-50 border-gray-200 text-gray-900 placeholder-gray-400'}`} />
          <button type="submit" disabled={status === 'loading' || !email}
            className="px-8 py-4 bg-gradient-to-r from-[#00D4AA] to-[#00BF9A] text-white font-semibold rounded-xl hover:shadow-lg hover:shadow-[#00D4AA]/25 transform hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-50 disabled:transform-none disabled:shadow-none whitespace-nowrap">
            {status === 'loading' ? (
              <span className="flex items-center justify-center space-x-2">
                <svg className="animate-spin w-5 h-5" viewBox="0 0 24 24" fill="none"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg>
                <span>Joining...</span>
              </span>
            ) : 'Join the Waitlist'}
          </button>
        </div>
      </form>
      {message && (
        <div className={`mt-4 flex items-center space-x-2 text-sm animate-fade-in ${status === 'success' ? 'text-[#00D4AA]' : 'text-red-500'}`}>
          {status === 'success' ? <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            : <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>}
          <span>{message}</span>
        </div>
      )}
      <p className={`mt-3 text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'} ${compact ? 'text-center' : ''}`}>We respect your privacy. Unsubscribe at any time.</p>
    </div>
  );
};

const HoldingPage = () => {
  const { isDark, toggleTheme } = useTheme();
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [boxVisibility, setBoxVisibility] = useState([0, 0, 0]); // Track visibility ratio for each box
  const [isDesktop, setIsDesktop] = useState(false);
  
  useEffect(() => { setIsLoaded(true); }, []);

  // Detect screen size changes
  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Cycling animation - ONLY for desktop
  useEffect(() => {
    if (!isDesktop) return;
    
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % 3);
    }, 2500);
    
    return () => clearInterval(interval);
  }, [isDesktop]);

  // Smooth scroll-based visibility tracking - ONLY for mobile/tablet
  useEffect(() => {
    if (isDesktop) return;
    
    const observer = new IntersectionObserver(
      (entries) => {
        const newVisibility = [...boxVisibility];
        
        entries.forEach((entry) => {
          const index = parseInt(entry.target.dataset.step);
          // Use intersection ratio directly for smooth transitions
          newVisibility[index] = entry.intersectionRatio;
        });
        
        setBoxVisibility(newVisibility);
      },
      { 
        threshold: Array.from({ length: 21 }, (_, i) => i * 0.05), // 0, 0.05, 0.1, ... 1.0
        rootMargin: '0px'
      }
    );

    const stepElements = document.querySelectorAll('.step-card');
    stepElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [isDesktop, boxVisibility]);

  return (
    <div className={`min-h-screen transition-colors duration-300 relative ${isDark ? 'bg-[#0a0a0a] text-white' : 'bg-white text-gray-900'}`}>
      <BackgroundOrbs isDark={isDark} />
      <div className="relative z-10 min-h-screen flex flex-col">
        <header className="w-full px-6 lg:px-12 py-6">
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <img src={isDark ? WHITE_LOGO : BLACK_LOGO} alt="BoxCrowd" className="h-10 sm:h-12 w-auto" />
            <div className="flex items-center space-x-3 sm:space-x-4">
              <ThemeToggle isDark={isDark} toggleTheme={toggleTheme} />
              <StatusBadge />
            </div>
          </div>
        </header>

        <main className="flex-1 flex items-center">
          <div className="w-full max-w-7xl mx-auto px-6 lg:px-12 py-12 lg:py-0">
            <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
              <div className="space-y-8">
                <div className="space-y-6">
                  <h1 className={`text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold leading-[1.1] tracking-tight ${isLoaded ? 'animate-fade-in-up opacity-0 delay-200' : 'opacity-0'}`}>
                    Money for{' '}<span className="bg-gradient-to-r from-[#00D4AA] to-[#00E8BA] bg-clip-text text-transparent">you</span>.
                    <br />Money for your<br />chosen{' '}<span className="bg-gradient-to-r from-[#00D4AA] to-[#00E8BA] bg-clip-text text-transparent">charity</span>.
                  </h1>
                  <div className={`${isLoaded ? 'animate-fade-in-up opacity-0 delay-300' : 'opacity-0'}`}>
                    <div className="w-16 h-1 bg-gradient-to-r from-[#00D4AA] to-[#00BF9A] rounded-full mb-6" />
                    <p className={`text-lg sm:text-xl leading-relaxed max-w-lg ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>A smarter way to crowdfund. Raise money for your goals while simultaneously giving to the causes you care about. Everyone wins.</p>
                  </div>
                </div>
                <EmailSignup isDark={isDark} />
                <div className="flex flex-wrap gap-3">
                  <FeaturePill isDark={isDark} delay="600" text="Secure & Regulated" icon={<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>} />
                  <FeaturePill isDark={isDark} delay="700" text="Charity Built-In" icon={<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg>} />
                  <FeaturePill isDark={isDark} delay="700" text="Fair & Transparent" icon={<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>} />
                </div>
              </div>
              <div className={`hidden lg:block ${isLoaded ? 'animate-slide-in-right opacity-0 delay-400' : 'opacity-0'}`}>
                <HeroIllustration isDark={isDark} />
              </div>
            </div>
          </div>
        </main>

        <section className="w-full max-w-5xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
          <div className="relative">
            <div className={`absolute -top-6 -left-2 text-8xl font-serif leading-none select-none ${isDark ? 'text-[#00D4AA]/10' : 'text-[#00D4AA]/15'}`}>&ldquo;</div>
            <div className={`rounded-3xl p-8 sm:p-12 lg:p-16 relative overflow-hidden backdrop-blur-sm border transition-colors duration-300 ${isDark ? 'bg-gradient-to-br from-white/[0.04] to-white/[0.01] border-white/[0.06]' : 'bg-gradient-to-br from-gray-50/80 to-white border-gray-200'}`}>
              <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00D4AA]/30 to-transparent" />
              <div className="relative z-10">
                <h2 className="text-sm font-semibold text-[#00D4AA] uppercase tracking-widest mb-6">Our Mission</h2>
                <p className={`text-lg sm:text-xl lg:text-2xl leading-relaxed lg:leading-relaxed font-light ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>We believe giving should be simple - no matter the goal. That's why we're building BoxCrowd, so you can focus on the contribution. No lengthy fundraising. No awkward asks. Just a powerful, perpetual cycle where every donation creates real opportunity.</p>
                <div className="mt-8 flex items-center space-x-4">
                  <div className="w-12 h-px bg-gradient-to-r from-[#00D4AA] to-transparent" />
                  <p className="text-[#00D4AA] font-semibold text-lg">Give more. Grow more. Change more.</p>
                </div>
              </div>
              <div className="absolute -bottom-20 -right-20 w-60 h-60 bg-[#00D4AA]/5 rounded-full blur-3xl" />
            </div>
          </div>
        </section>

        <section className="w-full max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
          <div className="text-center mb-12">
            <h2 className={`text-2xl sm:text-3xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>The BoxCrowd Difference</h2>
            <div className="w-12 h-1 bg-gradient-to-r from-[#00D4AA] to-[#00BF9A] rounded-full mx-auto" />
          </div>
          <div className="grid sm:grid-cols-3 gap-8">
            {[
              { step: '01', title: 'Give', desc: 'Make a contribution that matters. Every act of generosity sets something powerful in motion.', icon: <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg> },
              { step: '02', title: 'Grow', desc: 'Unlock opportunities for yourself while supporting causes you believe in. Generosity and ambition, hand in hand.', icon: <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg> },
              { step: '03', title: 'Transform', desc: 'Be part of a perpetual cycle of support and change. When you give, everyone wins.', icon: <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" /></svg> },
            ].map((item, index) => {
              // Desktop: binary active state for cycling
              // Mobile: continuous opacity based on scroll position
              const isActive = isDesktop ? (activeStep === index) : false;
              
              // Calculate smooth opacity for mobile based on visibility ratio
              const visibility = isDesktop ? 1 : boxVisibility[index];
              const mobileOpacity = Math.max(0.3, Math.min(1, visibility * 1.5)); // Range: 0.3 to 1.0
              const mobileScale = isDesktop ? 1 : (0.98 + (visibility * 0.07)); // Range: 0.98 to 1.05
              
              return (
                <div 
                  key={item.step} 
                  data-step={index}
                  style={{
                    opacity: isDesktop ? (isActive ? 1 : 1) : mobileOpacity,
                    transform: isDesktop 
                      ? (isActive ? 'scale(1.05)' : 'scale(1)') 
                      : `scale(${mobileScale})`
                  }}
                  className={`step-card group relative backdrop-blur-sm border rounded-2xl p-8 will-change-transform
                    transition-all duration-1000 ease-out
                    ${!isDesktop && 'pointer-events-none select-none'}
                    ${isDark 
                      ? `${isActive ? 'bg-white/[0.08] border-[#00D4AA]/40 shadow-[#00D4AA]/20 shadow-2xl' : 'bg-white/[0.03] border-white/[0.06]'} lg:hover:bg-white/[0.06] lg:hover:border-[#00D4AA]/20` 
                      : `${isActive ? 'bg-gradient-to-br from-[#00D4AA]/5 to-transparent border-[#00D4AA]/50 shadow-xl' : 'bg-white border-gray-200'} lg:hover:border-[#00D4AA]/40 lg:hover:shadow-lg`
                  }`}
                >
                  <div className="flex items-center space-x-3 mb-4">
                    <div 
                      style={{
                        opacity: isDesktop ? (isActive ? 1 : 0.5) : Math.max(0.4, mobileOpacity),
                        transform: isDesktop 
                          ? (isActive ? 'scale(1.1)' : 'scale(1)') 
                          : `scale(${0.95 + (visibility * 0.15)})`
                      }}
                      className={`w-10 h-10 rounded-xl flex items-center justify-center will-change-transform transition-all duration-1000 ease-out ${
                        isActive ? 'bg-[#00D4AA]/20 text-[#00D4AA]' : 'bg-[#00D4AA]/10 text-[#00D4AA]'
                      }`}
                    >
                      {item.icon}
                    </div>
                    <span 
                      style={{ opacity: isDesktop ? (isActive ? 1 : 0.4) : Math.max(0.3, mobileOpacity * 0.9) }}
                      className={`text-sm font-mono font-bold transition-all duration-1000 ease-out ${
                        isActive ? 'text-[#00D4AA]' : 'text-[#00D4AA]/40'
                      }`}
                    >
                      {item.step}
                    </span>
                  </div>
                  <h3 
                    style={{ opacity: isDesktop ? 1 : Math.max(0.5, mobileOpacity) }}
                    className={`text-lg font-semibold mb-2 transition-opacity duration-1000 ease-out ${
                      isDark ? 'text-white' : 'text-gray-900'
                    }`}
                  >
                    {item.title}
                  </h3>
                  <p 
                    style={{ opacity: isDesktop ? 1 : Math.max(0.4, mobileOpacity * 0.85) }}
                    className="text-gray-500 text-sm leading-relaxed transition-opacity duration-1000 ease-out"
                  >
                    {item.desc}
                  </p>
                  
                  {/* Pulse indicator - DESKTOP ONLY */}
                  {isActive && isDesktop && (
                    <div className="absolute -top-1 -right-1 w-3 h-3">
                      <span className="absolute inline-flex h-full w-full rounded-full bg-[#00D4AA] opacity-75 animate-ping"></span>
                      <span className="relative inline-flex rounded-full h-3 w-3 bg-[#00D4AA]"></span>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="mt-16 text-center">
            <p className={`mb-6 text-lg ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>Be the first to know when we launch.</p>
            <EmailSignup compact={true} isDark={isDark} />
          </div>
        </section>

        <footer className={`w-full px-6 lg:px-12 py-8 border-t transition-colors duration-300 ${isDark ? 'border-white/5' : 'border-gray-200'}`}>
          <div className="max-w-7xl mx-auto">
            {/* Top section with logo, copyright, and contact */}
            <div className="flex flex-col lg:flex-row items-center justify-between gap-6 mb-6">
              <div className="flex flex-col sm:flex-row items-center gap-4">
                <img src={isDark ? WHITE_LOGO : BLACK_LOGO} alt="BoxCrowd" className="h-6 w-auto opacity-50" />
                <span className={`text-sm ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>&copy; {new Date().getFullYear()} BoxCrowd. All rights reserved.</span>
              </div>
              
              {/* Contact Email */}
              <div className="flex items-center gap-2">
                <svg className={`w-4 h-4 ${isDark ? 'text-gray-500' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:contact@boxcrowd.com" className={`text-sm hover:text-[#00D4AA] transition-colors ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  contact@boxcrowd.com
                </a>
              </div>
            </div>

            {/* Bottom section with links */}
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-gray-200 dark:border-gray-800">
              <div className="flex items-center gap-6">
                <Link to="/privacy" className={`text-sm hover:text-[#00D4AA] transition-colors ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  Privacy Policy
                </Link>
                <Link to="/terms" className={`text-sm hover:text-[#00D4AA] transition-colors ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  Terms of Service
                </Link>
              </div>
              <div className={`text-xs ${isDark ? 'text-gray-600' : 'text-gray-400'}`}>
                Generosity meets ambition. Coming soon.
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default HoldingPage;

